import { ManufacturingOrder } from './manufacturing-order';
import { User } from './user';

export class UrgentManufacturingOrder {
  constructor(
    public hash: string,
    public date: number,
    public manufacturingOrder: ManufacturingOrder,
    public user: User
  ) {}
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/urgent-manufacturing-order.ts